import { g } from "../chunks/namespaces-client-BA-xInJF.mjs";
import { otto } from "./nexus-client.mjs";
const { logger, scope, Level, status } = g.debug ?? {};
const { sendLog } = otto.debug ?? {};
export {
  Level,
  logger,
  scope,
  sendLog,
  status
};
/*                                     */
